export default {
  id: 246,
  title: 'Target #246 - Limbs',
  url: 'https://cssbattle.dev/play/246',
  colors: ['#333333', '#EEEEEE'],
  solution:
    '<p a><p b><p c><p d><style>p[a],p[b]{width:292;height:128;left:43}p[c],p[d]{width:64;height:99;left:107;border-style:solid;border-color:#333}body{background:#333}p{position:fixed;background:#eee}p[a]{top:19;border-radius:0 0 64px 64px}p[b]{top:127;border-radius:64px 64px 0 0}p[c]{top:-16;border-width:0 50px 44px}p[d]{top:147;border-width:44px 50px 0',
}
